import Accounts from "@material-ui/icons/People";
import AccountsReactTables from "../views/Tables/AccountsReactTable";
import Assignment from "@material-ui/icons/Assignment";
import Build from "@material-ui/icons/Build"
import Download from "@material-ui/icons/CloudDownload";
import Dashboard from "../../wisene/views/Dashboard/Dashboard";
import DashboardIcon from "@material-ui/icons/Apps";
import DashboardSystems from "../views/DashboardSystems/DashboardSystems";
import DashboardSystemGroups from "../views/DashboardSystemGroups/DashboardSystemGroups";
import DashboardSystemGroup from "../views/DashboardSystemGroups/DashboardSystemGroup";
import EditAccountPage from "../views/EditAccount/EditAccountPage";
import HeatMap from "@material-ui/icons/Map";
import InstallerPanel from "../views/InstallerPages/InstallerPanel";
import DevicesList from "../views/InstallerPages/DevicesList";
import GatewaysList from "../views/InstallerPages/GatewaysList";
import Inspections from "../views/InstallerPages/Inspections";
import Agreements from "../views/InstallerPages/Agreements";
import Clients from "../views/InstallerPages/Clients";
import ServiceActions from "../views/InstallerPages/ServiceActions";
import AuditChanges from "../views/InstallerPages/AuditChanges";
import Simcards from "../views/InstallerPages/Simcards";
import Sms from "../views/InstallerPages/Sms";
import Routers from "../views/InstallerPages/Routers";
import LogsReactTable from "../views/Tables/LogsReactTable";
import NodesTables from "../views/Pages/NodeDetailsPage";
import SystemGraphPage from "../views/Pages/SystemGraphPage";
import SystemSettings from "../components/SystemSettings/SystemSettings";
import withAuth from "../../wisene/components/withAuth/withAuth";
import Node from '@material-ui/icons/Memory';
import PageviewIcon from '@material-ui/icons/Pageview';
import Cast from '@material-ui/icons/Cast';
import FileCopy from '@material-ui/icons/FileCopy';
import Business from '@material-ui/icons/Business';
import SimCard from '@material-ui/icons/SimCard';
import Router from '@material-ui/icons/Router';
import SmsIcon from '@material-ui/icons/Sms';
import SettingsPanel from "../views/Pages/SettingsPanel";
import Export from "../views/Pages/Export/Export";
import ListAlt from '@material-ui/icons/ListAlt';
import History from '@material-ui/icons/History';
import SystemsTable from "../views/InstallerPages/SystemsTable";
import SyncFailures from "../views/InstallerPages/SyncFailures";
import LeakRemove from '@material-ui/icons/LeakRemove';
import SystemDetails from "../views/InstallerPages/SystemDetails";
import SystemMaps from "../views/InstallerPages/SystemMaps";
import ImageIcon from '@material-ui/icons/Image';
import DeviceDetails from "../views/InstallerPages/DeviceDetails";
import Announcement from '@material-ui/icons/Announcement';
import DeviceErrors from "../views/InstallerPages/DeviceErrors";

var dashRoutes = [
  {
    path: "/devices/:nodeId/graph",
    component: withAuth(NodesTables),
    hidden: true,
  },

  {
    path: "/systems/:id/graph",
    component: withAuth(SystemGraphPage),
    hidden: true,
  },
  {
    path: "/systems/:id/system_settings",
    component: withAuth(SystemSettings),
    hidden: true,
  },
  {
    path: "/accounts/:accountId/edit_account",
    component: withAuth(EditAccountPage),
    hidden: true,
  },
  {
    path: "/systems/:id/dashboard",
    name: "Dashboard",
    icon: HeatMap,
    component: withAuth(Dashboard),
    hidden: false,
  },
  {
    path: "/systems",
    name: "Systems",
    icon: DashboardIcon,
    component: withAuth(DashboardSystems),
    hidden: false,
  },
  {
    path: "/logs",
    name: "Logs",
    icon: Assignment,
    component: withAuth(LogsReactTable),
    hidden: false,
  },
  {
    path: "/accounts",
    exact: true,
    name: "Accounts",
    icon: Accounts,
    component: withAuth(AccountsReactTables),
    hidden: false,
  },
];

export const installerRoutes = [
  {
    path: "/system-groups/:id/systems",
    name: "System Group",
    icon: HeatMap,
    component: withAuth(DashboardSystemGroup),
    hidden: true,
  },
  {
    path: "/system-groups",
    name: "System Groups",
    icon: DashboardIcon,
    component: withAuth(DashboardSystemGroups),
    hidden: false,
  },
  {
    path: "/installer_panel",
    name: "Installer Panel",
    icon: Build,
    component: withAuth(InstallerPanel),
    hidden: false
  },
  {
    path: "/inspections",
    name: "Inspections",
    icon: PageviewIcon,
    component: withAuth(Inspections),
    hidden: false
  },
  {
    path: "/agreements",
    name: "Agreements",
    icon: FileCopy,
    component: withAuth(Agreements),
    hidden: false
  },
  {
    path: "/clients",
    name: "Clients",
    icon: Business,
    component: withAuth(Clients),
    hidden: false
  },
  {
    path: "/service-actions",
    name: "Service actions",
    icon: Build,
    component: withAuth(ServiceActions),
    hidden: false
  },
  {
    path: "/gateways",
    name: "Gateways",
    icon: Cast,
    component: withAuth(GatewaysList),
    hidden: false
  },
  {
    path: "/export",
    name: "Export",
    icon: Download,
    component: withAuth(Export),
    hidden: false
  },
  {
    path: "/simcards",
    name: "SIM cards",
    icon: SimCard,
    component: withAuth(Simcards),
    hidden: false
  },
  {
    path: "/routers",
    name: "Routers",
    icon: Router,
    component: withAuth(Routers),
    hidden: false
  },
  {
    path: "/sms",
    name: "SMS",
    icon: SmsIcon,
    component: withAuth(Sms),
    hidden: false
  },
];

export const wiseneRoutes = [
  {
    path: "/devices",
    name: "Devices",
    icon: Node,
    component: withAuth(DevicesList),
    hidden: false
  },
  {
    path: "/systems-overview",
    name: "Systems Table",
    icon: ListAlt,
    component: withAuth(SystemsTable),
    hidden: false
  },
  {
    path: "/sync-failures",
    name: "Sync Failures",
    icon: LeakRemove,
    component: withAuth(SyncFailures),
    hidden: false
  },
  {
    path: "/system-maps",
    name: "System Maps",
    icon: ImageIcon,
    component: withAuth(SystemMaps),
    hidden: false
  },
  {
    path: "/systems/:systemID/details",
    component: withAuth(SystemDetails),
    hidden: true
  },
  {
    path: "/devices/:deviceID/details",
    component: withAuth(DeviceDetails),
    hidden: true
  },
  {
    path: "/device-errors",
    name: "Device Errors",
    icon: Announcement,
    component: withAuth(DeviceErrors),
    hidden: false
  },
  {
    path: "/audit-changes",
    name: "Audit",
    icon: History,
    component: withAuth(AuditChanges),
    hidden: false
  },
];

export const commonerRoutes = [
  {
    path: "/settings_panel",
    name: "Settings",
    icon: Build,
    component: withAuth(SettingsPanel),
    hidden: false
  },
];

// export const pushNotificationsRoutes = [
//   {
//     path: "/push-notifications-test",
//     name: "Push notifications",
//     icon: Build,
//     component: withAuth(PushNotifications),
//     hidden: false
//   },
// ];

export const loginRoutes = [
  {
    redirect: true,
    path: "/",
    pathTo: "/pages/login-page",
    name: "Dashboard"
  },
];



export default dashRoutes;
